var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex alert alert-light px-4 py-3"},[_c('div',{staticClass:"my-auto"},[_vm._t("icon")],2),_c('div',{staticClass:"pl-4"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }